import { WarningAlert } from 'src/components/WarningAlert';
import popupMessageImg from '../../assets/setup/popup_message.png';
import popupMessageCommandImg from '../../assets/setup/popup_message_command.png';

// component props interface 
interface Props {
    isMobileView: boolean;
}


export const PopupMessage: React.FC<Props> = ({ isMobileView }) => {
    return (
        <div className="flex flex-col justify-center gap-y-4">
            <p>Displays a popup message within Deck Hopper.</p>
            <img src={popupMessageImg} alt="Popup Message" width="500px" />
            <WarningAlert message="<a href='https://christinak.itch.io/deck-hopper-advanced'>Deck Hopper Advanced</a></strong> extension must be installed and running."/>
            <div>
                Use <b>Deck Hopper Popup Message</b> command to show a popup message.
                <ul className="flex flex-col gap-y-2 list-disc list-inside ms-8 ">
                    <li>Title - enter the title of the popup message</li>
                    <li>Message - enter the message of the popup message</li>
                    <li>Auto Close - Dismiss the message after X seconds. Set to 0 to not auto dismiss.</li>
                </ul>

            </div>
            <img src={popupMessageCommandImg} alt="Popup Message" width="800px" />
            <div>
                Use <b>Deck Hopper Close Popup Message</b> command to close the popup message within Deck Hopper.
            </div>
            <div>
                <p>Inside Deck Hopper Advanced premade deck, you can find example "Popup Message" and "Close Popup Message" buttons to show and close a popup message.
                </p>
            </div>

        </div>
    )
}